export default "__VITE_ASSET__DdsiAOjt__"